import React from "react";

import { FieldStatusIcon } from "../shared/FieldStatusIcon";

interface TargetAudienceFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export const TargetAudienceField: React.FC<TargetAudienceFieldProps> = ({
  value,
  onChange,
}) => {
  const getFieldStatus = () => {
    if (!value || value.trim().length === 0) return "empty";
    if (value.trim().length < 20) return "partial";
    return "complete";
  };

  const status = getFieldStatus();
  const placeholder =
    "Existing premium credit card holders aged 28-55, primarily high-income professionals in urban markets, who have held their current card for 12+ months and are eligible for an upgrade based on spending patterns and credit score thresholds.";

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <FieldStatusIcon status={status} />
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-base font-semibold text-white">
              Target Audience <span className="text-white/40">(optional)</span>
            </span>
          </div>
        </div>
      </div>

      <div className="relative">
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="min-h-[140px] w-full resize-none rounded-md border border-white/10 bg-white/5 px-4 py-3 text-white placeholder:text-white/30 focus:border-amber-400/50 focus:outline-none"
        />
        <div className="absolute bottom-3 right-3 text-xs text-white/30">
          {value.length} characters
        </div>
      </div>

      <p className="text-xs text-white/50">
        Include details like demographics, user behaviors, pain points, and
        goals to help tailor your experiment effectively.
      </p>
    </div>
  );
};
